<template>
    <b-spinner v-if="progress === 0" small variant="success" label="Spinning"></b-spinner>
    <svg v-else class="file-progress-ring" viewBox="0 0 36 36">
        <circle cx="18" cy="18" r="14" fill="none" stroke="#e9ecef" stroke-width="6"/>
        <circle cx="18" cy="18" r="14" fill="none"
            stroke="#28a745" stroke-width="6"
            :stroke-dasharray="`${progress * 0.8796} 87.96`"
            stroke-linecap="round"
            style="transform-origin: center; transform: rotate(-90deg)"
        />
    </svg>
</template>

<script>
export default {
    name: 'FileDownloadRing',
    props: {
        progress: {
            type: Number,
            default: 0,
        },
    },
};
</script>

<style scoped>
.file-progress-ring {
    width: 1.1rem;
    height: 1.1rem;
}
</style>